(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["galantte-ugc-videos"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var modal = document.getElementById('galantte-ugc-modal');
    var modalVideo = modal && modal.querySelector('.galantte-ugc__modal-video');
    var modalClose = modal && modal.querySelector('.galantte-ugc__modal-close');
    var modalBackdrop = modal && modal.querySelector('.galantte-ugc__modal-backdrop');

    function openModal(videoSources, videoUrl) {
      if (!modal || !modalVideo) return;

      modalVideo.innerHTML = '';
      modalVideo.removeAttribute('src');
      modalVideo.muted = false;

      if (videoSources && videoSources.length) {
        videoSources.forEach(function(src) {
          var sourceEl = document.createElement('source');
          sourceEl.src = src.url;
          sourceEl.type = src.mime_type;
          modalVideo.appendChild(sourceEl);
        });
      } else if (videoUrl) {
        modalVideo.src = videoUrl;
      }

      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      modalVideo.load();
      modalVideo.muted = false;
      modalVideo.play().catch(function() {});
    }

    function closeModal() {
      if (!modal || !modalVideo) return;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      modalVideo.pause();
      modalVideo.innerHTML = '';
      modalVideo.removeAttribute('src');
      modalVideo.load();
    }

    function duplicateTrackForMarquee(track) {
      if (!track || track.getAttribute('data-g-ugc-marquee-duped') === 'true') return;
      var cards = [];
      for (var i = 0; i < track.children.length; i++) {
        var el = track.children[i];
        if (el.classList && el.classList.contains('galantte-ugc__card')) cards.push(el);
      }
      if (!cards.length) return;
      cards.forEach(function(card) {
        var clone = card.cloneNode(true);
        clone.classList.add('galantte-ugc__card--clone');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      track.setAttribute('data-g-ugc-marquee-duped', 'true');
    }

    /**
     * Auto-advance scrollLeft on the viewport (native overflow = drag desktop + swipe touch).
     * Speed matches the old CSS marquee: loop duration = max(14s, halfWidth/38px/s) → px/s = half/duration.
     * Pauses while the user is interacting; resumes after a short idle.
     * Important: iOS fires pointercancel when native scrolling starts — do NOT resume on cancel alone,
     * or auto-scroll fights the swipe and the carousel feels stuck.
     */
    function setupMarqueeScroll(viewport, track, wrapper) {
      if (!viewport || !track || !wrapper) return;
      if (track.getAttribute('data-g-ugc-marquee-duped') !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      track.classList.add('galantte-ugc__track--marquee-scroll');

      var MARQUEE_BASE_PX_PER_SEC = 38;
      var MARQUEE_MIN_DURATION_SEC = 14;
      var RESUME_IDLE_MS = 1800;

      function marqueeSpeedPxPerSec(half) {
        if (half <= 0) return 0;
        var durationSec = Math.max(MARQUEE_MIN_DURATION_SEC, half / MARQUEE_BASE_PX_PER_SEC);
        return half / durationSec;
      }

      var hovering = false;
      var interacting = false;
      var resumeTimer = null;
      var lastTs = 0;
      /* iOS Safari often ignores sub-pixel scrollLeft writes; accumulate fractional motion then apply whole pixels. */
      var pendingPx = 0;
      var ignoreScrollUntil = 0;

      /* Phones report (hover: none): pause-on-hover is meaningless and touch can emit mouseenter without mouseleave, leaving hovering stuck true — which stops auto-scroll entirely on mobile. */
      var hoverPauseEnabled = false;
      try {
        hoverPauseEnabled = window.matchMedia('(hover: hover)').matches;
      } catch (e) {}

      function shouldAdvance() {
        return !hovering && !interacting;
      }

      function pauseForUser() {
        interacting = true;
        pendingPx = 0;
        if (resumeTimer) {
          clearTimeout(resumeTimer);
          resumeTimer = null;
        }
      }

      function scheduleResume() {
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function() {
          interacting = false;
          resumeTimer = null;
          lastTs = 0;
        }, RESUME_IDLE_MS);
      }

      function applyScrollLeft(nextLeft) {
        var x = Math.round(nextLeft);
        /* Ignore the scroll event our own writes produce (async on some engines). */
        ignoreScrollUntil = performance.now() + 64;
        /* Direct assignment is most reliable on WebKit iOS; scrollTo options can be flaky. */
        viewport.scrollLeft = x;
      }

      function tick(ts) {
        if (!viewport.isConnected) return;
        if (!lastTs) {
          lastTs = ts;
          requestAnimationFrame(tick);
          return;
        }
        var dt = Math.min((ts - lastTs) / 1000, 0.064);
        lastTs = ts;

        if (shouldAdvance()) {
          var half = track.scrollWidth / 2;
          var speed = marqueeSpeedPxPerSec(half);
          if (half > 1 && speed > 0) {
            pendingPx += speed * dt;
            var step = pendingPx >= 0 ? Math.floor(pendingPx) : Math.ceil(pendingPx);
            if (step !== 0) {
              pendingPx -= step;
              var cur = viewport.scrollLeft;
              var nextLeft = cur + step;
              if (nextLeft >= half - 1) {
                nextLeft -= half;
                pendingPx = 0;
              }
              applyScrollLeft(nextLeft);
            }
          }
        }
        requestAnimationFrame(tick);
      }

      if (hoverPauseEnabled) {
        wrapper.addEventListener('mouseenter', function() {
          hovering = true;
        });
        wrapper.addEventListener('mouseleave', function() {
          hovering = false;
        });
      }

      /* touchstart is more reliable than pointerdown alone on iOS scroll views */
      viewport.addEventListener('touchstart', pauseForUser, { passive: true });
      viewport.addEventListener('pointerdown', pauseForUser);

      viewport.addEventListener('touchend', scheduleResume, { passive: true });
      viewport.addEventListener('touchcancel', scheduleResume, { passive: true });
      viewport.addEventListener('pointerup', scheduleResume);
      /* Keep paused on pointercancel — native scroll often starts with cancel on iOS */
      viewport.addEventListener('pointercancel', pauseForUser);

      viewport.addEventListener(
        'scroll',
        function() {
          if (performance.now() < ignoreScrollUntil) return;
          pauseForUser();
          scheduleResume();
        },
        { passive: true }
      );

      /* Wait for layout + fonts so scrollWidth/half are non-zero on mobile Safari */
      requestAnimationFrame(function() {
        void track.scrollWidth;
        void viewport.offsetWidth;
        requestAnimationFrame(tick);
      });
    }

    function bindSection(section) {
      if (!section || section.getAttribute('data-g-ugc-bound') === '1') return;
      section.setAttribute('data-g-ugc-bound', '1');

      var track = section.querySelector('.galantte-ugc__track');
      var viewport = section.querySelector('.galantte-ugc__track-viewport');
      var wrapper = section.querySelector('.galantte-ugc__carousel-wrapper');
      var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (track && !mqReduce.matches) {
        duplicateTrackForMarquee(track);
        setupMarqueeScroll(viewport, track, wrapper);
      } else if (track) {
        track.classList.add('galantte-ugc__track--reduced');
      }

      section.querySelectorAll('.galantte-ugc__play-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var sourcesAttr = btn.getAttribute('data-video-sources');
          var videoUrl = btn.getAttribute('data-video-url');
          var sources = null;
          if (sourcesAttr) {
            try {
              sources = JSON.parse(sourcesAttr);
            } catch (e) {}
          }
          openModal(sources, videoUrl);
        });
      });
    }

    function initAll() {
      document.querySelectorAll('[id^="GalantteUGC-"]').forEach(bindSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function(ev) {
      if (ev && ev.target) {
        var el = ev.target.querySelector && ev.target.querySelector('[id^="GalantteUGC-"]');
        if (el) bindSection(el);
      }
    });

    if (modalClose) modalClose.addEventListener('click', closeModal);
    if (modalBackdrop) modalBackdrop.addEventListener('click', closeModal);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
